// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteOrderPage_root__q1w8u {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
    -webkit-user-select: none;
  user-select: none;
  
}
.RouteOrderPage_list__URML1 {
  flex: 1 1;
  overflow-y: auto;
  margin-bottom: 90px;
  list-style: none;
  padding: 0 8px;
}
.RouteOrderPage_item__mzkqP {
  position: relative;
  padding: 12px;
  margin: 4px 8px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.2s;
}
.RouteOrderPage_item__mzkqP:hover {
  background: #f1f1f1;
}
.RouteOrderPage_address__D8GJO {
  flex: 1 1;
  font-size: 1rem;
  color: #333;
  -webkit-user-select: none;
  user-select: none;
}
.RouteOrderPage_badge__5uQX6 {
  background-color: #007bff;
  color: #fff;
  border-radius: 30%;
  padding: 0px 8px;
  font-size: 1.0rem;
  -webkit-user-select: none;
  user-select: none;
}
.RouteOrderPage_footer__XsFuo {
  position: absolute;
  bottom: 40px;  /* отступ снизу, чтобы не перекрывать кнопку закрытия модалки */
  left: 0;
  right: 0;
  background: #fff;
  padding: 12px 0;
  display: flex;
  justify-content: center;
  gap: 12px;
  border-top: 1px solid #ddd;
  z-index: 10;
}
.RouteOrderPage_autoArrange__aMrj7 {
  background-color: #17a2b8;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
}
.RouteOrderPage_save__fiSZc {
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
}
.RouteOrderPage_save__fiSZc:disabled {
  background-color: #94d3a2;
  cursor: not-allowed;
}
.RouteOrderPage_modalOverlay__qhfMw {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.RouteOrderPage_modalContent__gD6AQ {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
}
.RouteOrderPage_modalButtons__vIc\\+\\+ {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0;
}
.RouteOrderPage_modalButton__x9QzW {
  padding: 6px 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  background: #f8f9fa;
  border-radius: 4px;
  cursor: pointer;
}
.RouteOrderPage_modalButton__x9QzW:hover {
  background: #e2e6ea;
}
.RouteOrderPage_modalCancel__FHkUW {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/RouteOrderPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;IACd,yBAAyB;EAG3B,iBAAiB;;AAEnB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,yBAAyB;EAGzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EAGzB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY,GAAG,+DAA+D;EAC9E,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB","sourcesContent":[".root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  background: #fff;\r\n    -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  \r\n}\r\n.list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  margin-bottom: 90px;\r\n  list-style: none;\r\n  padding: 0 8px;\r\n}\r\n.item {\r\n  position: relative;\r\n  padding: 12px;\r\n  margin: 4px 8px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  transition: background 0.2s;\r\n}\r\n.item:hover {\r\n  background: #f1f1f1;\r\n}\r\n.address {\r\n  flex: 1;\r\n  font-size: 1rem;\r\n  color: #333;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n.badge {\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border-radius: 30%;\r\n  padding: 0px 8px;\r\n  font-size: 1.0rem;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n.footer {\r\n  position: absolute;\r\n  bottom: 40px;  /* отступ снизу, чтобы не перекрывать кнопку закрытия модалки */\r\n  left: 0;\r\n  right: 0;\r\n  background: #fff;\r\n  padding: 12px 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  border-top: 1px solid #ddd;\r\n  z-index: 10;\r\n}\r\n.autoArrange {\r\n  background-color: #17a2b8;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 8px 16px;\r\n  cursor: pointer;\r\n}\r\n.save {\r\n  background-color: #28a745;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 8px 16px;\r\n  cursor: pointer;\r\n}\r\n.save:disabled {\r\n  background-color: #94d3a2;\r\n  cursor: not-allowed;\r\n}\r\n.modalOverlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.modalContent {\r\n  background: #fff;\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n}\r\n.modalButtons {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin: 12px 0;\r\n}\r\n.modalButton {\r\n  padding: 6px 10px;\r\n  font-size: 1rem;\r\n  border: 1px solid #ccc;\r\n  background: #f8f9fa;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.modalButton:hover {\r\n  background: #e2e6ea;\r\n}\r\n.modalCancel {\r\n  background: none;\r\n  border: none;\r\n  color: #dc3545;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `RouteOrderPage_root__q1w8u`,
	"list": `RouteOrderPage_list__URML1`,
	"item": `RouteOrderPage_item__mzkqP`,
	"address": `RouteOrderPage_address__D8GJO`,
	"badge": `RouteOrderPage_badge__5uQX6`,
	"footer": `RouteOrderPage_footer__XsFuo`,
	"autoArrange": `RouteOrderPage_autoArrange__aMrj7`,
	"save": `RouteOrderPage_save__fiSZc`,
	"modalOverlay": `RouteOrderPage_modalOverlay__qhfMw`,
	"modalContent": `RouteOrderPage_modalContent__gD6AQ`,
	"modalButtons": `RouteOrderPage_modalButtons__vIc++`,
	"modalButton": `RouteOrderPage_modalButton__x9QzW`,
	"modalCancel": `RouteOrderPage_modalCancel__FHkUW`
};
export default ___CSS_LOADER_EXPORT___;
